import { render, staticRenderFns } from "./ProcessTable.vue?vue&type=template&id=485265f0&"
import script from "./ProcessTable.vue?vue&type=script&lang=js&"
export * from "./ProcessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports